import { subWindow } from "../js/subWindow.js";
export default {
  namespaced: true, // 使用namespaced确保模块的state、mutations、actions和getters是命名空间化的

  state() {
    return {
      showSecondScreen: false,
    };
  },

  mutations: {
    SET_showSecondScreen(state, bol) {
      state.showSecondScreen = bol;
      // 桌面端
      if (window.isWebview) {
        if (bol) {
          return subWindow.create();
        }
        subWindow.remove();
      }
    },

    // 其他mutations...
  },

  actions: {
    // 其他actions...
  },

  getters: {
    getShowSecondScreen: (state) => state.showSecondScreen,
    // 其他getters...
  },
};
